<div class="list-container">
    <rask-list [data]="leverantorsordrar" [getSelectedFromRoute]="true">
        <rask-list-column header="{{ 'LEVERANTORSORDER_LIST_LEVERANTOR' | translate }}" field="leverantor"
            [sortable]="true">
            <ng-template let-row="row">
                <a [routerLink]="[row.id]">
                    {{row.leverantor}} {{ row.leverantorHk }} {{ row.leverantorInternr}}
                </a>
            </ng-template>
        </rask-list-column>
        <rask-list-column header="{{ 'LEVERANTORSORDER_LIST_ORDERNUMMER' | translate }}" field="ordernr"
            [sortable]="true"></rask-list-column>
        <rask-list-column header="{{ 'LEVERANTORSORDER_LIST_PERIODFROM' | translate }}" field="periodFrom"
            [sortable]="true"></rask-list-column>
        <rask-list-column header="{{ 'LEVERANTORSORDER_LIST_PERIODTOM' | translate }}" field="periodTom"
            [sortable]="true"></rask-list-column>
        <rask-list-column header="{{ 'LEVERANTORSORDER_LIST_STATUS' | translate }}" field="status" [sortable]="true"
            [nowrap]="true"></rask-list-column>
        <rask-list-column header="{{ 'LEVERANTORSORDER_LIST_HANDELSSORTIMENTSGRUPP' | translate }}"
            field="handelssortimentsgrupp" [sortable]="true" [tooltip]="true"></rask-list-column>
        <rask-list-column header="{{ 'LEVERANTORSORDER_LIST_AVTALSANSVARIG' | translate }}" field="avtalsansvarig"
            [sortable]="true"></rask-list-column>
    </rask-list>
</div>